export default __webpack_public_path__ + "static/media/slide5.acc92a17.webp";